export const cardTypes = [
	"Planeswalker",
	"Battle",
	"Creature",
	"Land",
	"Sorcery",
	"Instant",
	"Artifact",
	"Enchantment",
] as const;

export const pluralizedCardTypes = {
	Planeswalker: "Planeswalkers",
	Battle: "Battles",
	Creature: "Creatures",
	Sorcery: "Sorceries",
	Instant: "Instants",
	Land: "Lands",
	Artifact: "Artifacts",
	Enchantment: "Enchantments",
};

export const cardTypeSortOrder = [
	"Planeswalker",
	"Battle",
	"Creature",
	"Sorcery",
	"Instant",
	"Artifact",
	"Enchantment",
	"Land",
	"Attraction",
] as const;
